module.exports = __webpack_public_path__ + "img/Warehousing-hero.364cab1c.jpg";